import React from 'react';
import { TextLink } from '@cvent/carina/components/TextLink';
import { useTranslate } from 'nucleus-text';

import { useFooterStyle } from '@hooks/style/useFooterStyle';

type FooterLinksProps = {
  testID: string;
};

export const FooterLinks = ({ testID }: FooterLinksProps): JSX.Element => {
  const { translate } = useTranslate();
  const { footerLink } = useFooterStyle();

  return (
    <>
      <TextLink
        href="https://www.cvent.com/en/cvent-global-privacy-policy#cookies"
        neutral
        target="_blank"
        rel="noopener noreferrer"
        testID={`${testID}_link__privacy_policy`}
        css={footerLink}
      >
        {translate('footer_privacy')}
      </TextLink>
      <TextLink
        href="https://www.cvent.com/en/cvent-general-terms-of-use"
        neutral
        target="_blank"
        rel="noopener noreferrer"
        testID={`${testID}_link__terms_of_use`}
        css={footerLink}
      >
        {translate('footer_terms')}
      </TextLink>
      <TextLink
        href="https://www.cvent.com/en/contact/support"
        neutral
        target="_blank"
        rel="noopener noreferrer"
        testID={`${testID}_link__help_and_support`}
        css={footerLink}
      >
        {translate('footer_help')}
      </TextLink>
    </>
  );
};
